import React from 'react';
import cx from 'classnames';
// constants
import { CROSS } from '@/constants/icons/unicode';
// styles
import styles from './CloseIcon.module.scss';
const CloseIcon = ({ onModalClose, className }) => {
    return (React.createElement("div", { className: cx(className, styles.closeButton), onClick: onModalClose }, String.fromCharCode(CROSS)));
};
export default CloseIcon;
